
const TOGGLE_DARK_MODE = 'TOGGLE_DARK_MODE';
const TOGGLE_All = 'TOGGLE_All';
const TOGGLE_LANGUAGE = 'TOGGLE_LANGUAGE';
const SET_SIDEBAR_STYLE = 'SET_SIDEBAR_STYLE';
 
export{
    TOGGLE_DARK_MODE,
    TOGGLE_All,
    TOGGLE_LANGUAGE,
    SET_SIDEBAR_STYLE
}